import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/home/Home.vue"; 
import Demo from "../views/empresa/demo.vue";
import HomePage from "../home-page.vue";
import LayoupVe from "../layoup-ve.vue";
import Interes from "../views/help/Interes.vue";
import LayoupPa from "../layoup-pa.vue";
import HomePa from "../views/home/HomePa.vue";

const routes = [

  {
    path: '/',
    name: 'home',
    meta: { title: "Alliance - Inteligencia contable" },
    component: HomePage // Se carga HomeView
  },

  // RUTA /VE CON RUTAS HIJAS ANIDADAS
  {
    path: '/ve',
    name: 've-layout',
    component: LayoupVe, 
    children: [
      {
        path: "",
        name: "Home",
        meta: { title: "Alliance - Inteligencia contable" },
        component: Home
      },
      {
        path: "Interes",
        name: "ve-Frequently asked questions",
        meta: { title: "Interes" },
        component: Interes
      },
      {
        path: "crear_cuenta",
        name: "ve-Crear cuenta",
        meta: { title: "Crear cuenta" },
        component: Demo
      }
    ]
  }, 
  {
    path: '/pa',
    name: 'pa-layout',
    component: LayoupPa, 
    children: [
      {
        path: "",
        name: "Home-Pa",
        meta: { title: "Alliance - Inteligencia contable" },
        component: HomePa
      },
      {
        path: "Interes",
        name: "pa-Frequently asked questions",
        meta: { title: "Interes" },
        component: Interes
      },
      {
        path: "crear_cuenta",
        name: "pa-Crear cuenta",
        meta: { title: "Crear cuenta" },
        component: Demo
      }
    ]
  }   
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

export default router;
